// removed by extract-text-webpack-plugin
module.exports = {"background":"s-m3G8pPSdeLR4lP5z4vq","fadein":"FJkzGUjjX-ZwagQKmZV1f","exiting":"_7ed4MdYsDYGEYJj5-SYct","exited":"_8UUNq11rrwdbm2tui8BIV","container":"_1FN6bzQJhD4wDf_LwRkIv1","closeButton":"_2EOpDCsRLt7f3WdG4A7iky","content":"_140UYwRaFkV5iayopbHeC0"};


//////////////////
// WEBPACK FOOTER
// ./app/style/dialog.scss
// module id = 11
// module chunks = 0